import "../style/dashboard/Dashboard.css";
import DashboardShipmentCount from "../components/dashboard/DashboardShipmentCount";
import NotificationBar from "../components/sidebar/NotificationBar";
import { Box } from "@mui/system";
import { DynamicTitle } from "../utils/DynamicTitle";
import { useSetRecoilState } from "recoil";
import { emailState, nameState, surnameState } from "../atoms/membership";
import { useEffect, useState } from "react";
import WrapperStyle from "../utils/WrapperStyle";
import ProfileStatus from "../components/dashboard/ProfileStatus";
// import PageTransition from "../utils/PageTransition";
import { useCookies } from "react-cookie";
import axios from "../api/axios";
import ChangePasswordInfo from "../components/home/ChangePasswordInfo";
import ChangePasswordInfoBigger from "../components/home/ChangePasswordInfoBigger";
import ChangePasswordInfoBiggerSecond from "../components/home/ChangePasswordInfoBiggerSecond";
import ChangePasswordInfoSmall from "../components/home/ChangePasswordInfoSmall";
import NewsModal from "../components/home/NewsModal";
import NisanImg from "../img/images/23nisan.png";

const Dashboard = () => {
  DynamicTitle("Pano | Cargologi");

  const [token] = useCookies(["jwt"]);
  const jwt = token.jwt;
  axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;

  const userInfo = JSON.parse(localStorage.getItem("user"));
  // const userStatus = userInfo?.user?.user_member?.status;

  // const setMemberStatusModal = useSetRecoilState(memberStatusModalState);
  const setName = useSetRecoilState(nameState);
  const setSurname = useSetRecoilState(surnameState);
  const setEmail = useSetRecoilState(emailState);

  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isModalOpenBigger, setIsModalOpenBigger] = useState(true);
  const [isModalOpenBiggerSecond, setIsModalOpenBiggerSecond] = useState(true);
  const [isModalOpenSmall, setIsModalOpenSmall] = useState(true);
  const [isHolidayModalOpen, setIsHolidayModalOpen] = useState(true);

  const holidayNews = {
    title: "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı Duyurusu",
    image: NisanImg,
    content: [
      "Değerli Üyelerimiz,",
      "23 Nisan Perşembe günü Ulusal Egemenlik ve Çocuk Bayramı sebebi ile operasyona bir gün ara verilecektir.",
      "24 Nisan Cuma günü itibari ile normal çalışma düzenimize devam edeceğiz.",
      "Bu vesileyle 23 Nisan Ulusal Egemenlik ve Çocuk Bayramınızı kutlarız. Dünya Çocuklarla Güzel :)"
    ]
  };

  const setHolidayModal = (value) => {
    setIsHolidayModalOpen(value);
  };

  // Profile verisini çek ve localStorage'ı güncelle (izinler için)
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get('profile');
        if (response.data?.data) {
          // Mevcut user objesini al
          const currentUser = JSON.parse(localStorage.getItem("user"));

          // User datasını güncelle (izinleri de içerir)
          currentUser.user = response.data.data;

          // LocalStorage'a kaydet
          localStorage.setItem("user", JSON.stringify(currentUser));

          // Recoil state'leri güncelle
          setName(response.data.data.name);
          setSurname(response.data.data.surname);
          setEmail(response.data.data.email);
        }
      } catch (error) {
        console.error("Profile yüklenirken hata:", error);
        // Hata durumunda mevcut verilerle devam et
        setName(userInfo?.user.name);
        setSurname(userInfo?.user.surname);
        setEmail(userInfo?.user.email);
      }
    };

    fetchProfile();
  }, [setName, setSurname, setEmail]);

  // useEffect(() => {
  //   if (Number(userStatus) !== 2) {
  //     setMemberStatusModal(true);
  //   }
  // }, [setMemberStatusModal, userStatus]);

  return (
    <>
      <section className="dashboard">
        <NotificationBar />
        {/* <NewsModal
          open={isHolidayModalOpen}
          setOpen={setHolidayModal}
          newsData={holidayNews}
        /> */}
        {/* <ChangePasswordInfo open={isModalOpen} setOpen={setIsModalOpen} /> */}
        {/* <ChangePasswordInfoBigger
          open={isModalOpenBigger}
          setOpen={setIsModalOpenBigger}
        /> */}
        {/* <ChangePasswordInfoBiggerSecond
          open={isModalOpenBiggerSecond}
          setOpen={setIsModalOpenBiggerSecond}
        /> */}
        {/* <ChangePasswordInfoSmall open={isModalOpenSmall} setOpen={setIsModalOpenSmall} /> */}
        {/* <PageTransition> */}
        <ProfileStatus />
        <Box style={WrapperStyle()} className="dashboard-wrapper">
          <DashboardShipmentCount />
        </Box>
        {/* </PageTransition> */}
      </section>
    </>
  );
};

export default Dashboard;
